<script setup>
import {Bar} from 'vue-chartjs'
import { CategoryScale, Chart as ChartJS, Filler, LinearScale, LineElement, PointElement, BarElement } from "chart.js";
import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';
ChartJS.register(LinearScale, CategoryScale, LineElement, PointElement, Filler, BarElement)

const props = defineProps({
  datacollection: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Object,
    default: () => ({}),
  }
});

</script>

<template>
  <Bar
    :options="{
      ...options,
      indexAxis: 'y',
    }"
    :data="datacollection"
  />
</template>